// Design signature (§18.1 "calm, dense, trustworthy"): a single tick on a rounded teal
// field — the same glyph as public/favicon.svg. It echoes the app's own vocabulary
// (Confirmed/Likely/Tentative chips, §18.1) rather than a generic checkmark-in-a-circle.
export function Mark({ size = 24 }: { size?: number }): React.JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className="shrink-0">
      <rect width="32" height="32" rx="8" fill="var(--primary)" />
      <path
        d="M9 17.2 L14 22 L23.5 10.5"
        fill="none"
        stroke="var(--primary-ink)"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
